import { Link } from "react-router-dom";
import styled from "styled-components";
const ArticleListElement = ({
  category = "",
  no = "",
  title = "",
  date = "",
}) => {
  return (
    <A to={`/boards/${category}/${no}`}>
      <span className="title">{title}</span>
      <span className="date">{date}</span>
    </A>
  );
};
export default ArticleListElement;
const A = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1.5rem;
  padding: 1.15rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.line};
  transition: background-color 0.15s;
  & > .title {
    flex: 1;
    font-size: 1.05rem;
    font-weight: 500;
    line-height: 1.55;
    color: ${({ theme }) => theme.colors.foreground.normal};
    transition: color 0.15s;
  }
  & > .date {
    flex-shrink: 0;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.monotone.medium};
    font-variant-numeric: tabular-nums;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.monotone.extralight};
    & > .title {
      color: ${({ theme }) => theme.colors.accent};
    }
  }
  @media (max-width: 575px) {
    flex-direction: column;
    gap: 0.3rem;
    padding: 1rem 0.25rem;
  }
`;
